import ajax from '../../utils/ajax';

interface TimeRemainingResponse {
  millisecondsRemaining: number;
}

export default {
  getTimeRemaining() : Promise<TimeRemainingResponse> {
    return ajax.get('/api/cart/timer');
  },

  transferSession() : Promise<void> {
    return ajax.post('/api/session/transfer?reason=expiration');
  },
};
